import { render, staticRenderFns } from "./OwnerCoverage.vue?vue&type=template&id=02be31a7&"
import script from "./OwnerCoverage.vue?vue&type=script&lang=js&"
export * from "./OwnerCoverage.vue?vue&type=script&lang=js&"
import style0 from "./OwnerCoverage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports